import type { Meta, StoryFn } from '@storybook/react';

import { BooleanDisplay } from '@pega/cosmos-react-core';
import type { BooleanDisplayProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Boolean',
  component: BooleanDisplay
} as Meta;

export const BooleanDisplayDemo: StoryFn<BooleanDisplayProps> = (args: BooleanDisplayProps) => {
  return (
    <BooleanDisplay value={args.value} trueLabel={args.trueLabel} falseLabel={args.falseLabel} />
  );
};

BooleanDisplayDemo.args = {
  value: true,
  trueLabel: 'Yes',
  falseLabel: 'No'
};

BooleanDisplayDemo.argTypes = {
  value: { control: { type: 'boolean' } },
  trueLabel: { control: { type: 'text' } },
  falseLabel: { control: { type: 'text' } }
};
